export default __webpack_public_path__ + "b844297c67d95cbcc07b10ec0137c8fc.png";